import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { STORE_REPOSITORY } from './repositories/IStore.repository';
import { StoreRepository } from './repositories/store.repository';
import { STORE_SERVICE } from './services/IStore.service';
import { StoreService } from './services/store.service';
import { StoreCategoriesEffects } from './state/categories/store-categories.effects';
import { StoreCategoriesStore } from './state/categories/store-categories.store';
import { StoreConfigurationEffects } from './state/configuration/store-configuration.effects';
import { StoreConfigurationStore } from './state/configuration/store-configuration.store';
import { StoreCouponsEffects } from './state/coupons/store-coupons.effects';
import { StoreCouponsStore } from './state/coupons/store-coupons.store';
import { StoreImagesEffects } from './state/images/store-images.effects';
import { StoreImagesStore } from './state/images/store-images.store';
import { StoreOrdersEffects } from './state/orders/store-orders.effects';
import { StoreOrdersStore } from './state/orders/store-orders.store';
import { StoreProductsEffects } from './state/products/store-products.effects';
import { StoreProductsStore } from './state/products/store-products.store';
import { ecommerceReducer } from './state/store.reducer';
import { ECOMMERCE_STORE_KEY } from './state/store.selectors';
import { StorePageStore } from './state/store.store';
import { StoreVariationsEffects } from './state/variations/store-variations.effects';
import { StoreVariationsStore } from './state/variations/store-variations.store';

interface ModuleOptionsInterface {
  providers: Provider[];
}

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    StoreModule.forFeature(ECOMMERCE_STORE_KEY, ecommerceReducer),
    EffectsModule.forFeature([
      StoreCategoriesEffects,
      StoreImagesEffects,
      StoreOrdersEffects,
      StoreProductsEffects,
      StoreCouponsEffects,
      StoreVariationsEffects,
      StoreConfigurationEffects,
    ]),
  ],
  exports: [],
})
export class StoreCoreModule {
  static forRoot(
    config?: ModuleOptionsInterface
  ): ModuleWithProviders<StoreCoreModule> {
    return {
      ngModule: StoreCoreModule,
      providers: [
        { provide: STORE_SERVICE, useClass: StoreService },
        { provide: STORE_REPOSITORY, useClass: StoreRepository },
        ...(config?.providers || []),
        StoreCategoriesStore,
        StoreImagesStore,
        StoreOrdersStore,
        StoreProductsStore,
        StoreCouponsStore,
        StoreVariationsStore,
        StorePageStore,
        StoreConfigurationStore
      ],
    };
  }

  static forChild() {
    return {
      ngModule: StoreCoreModule,
    };
  }
}
